import { createContext, useContext, useEffect, useState } from 'react';
import { trackEvent } from 'utils/tracking';
import ApproveAccessModal from 'v2/components/modals/ApproveAccessModal';

export const Context = createContext(null);

export const ApproveAccessModalProvider = ({ children }: { children: React.ReactNode }) => {
  const [open, setOpen] = useState<boolean>(false);

  useEffect(() => {
    if (open) {
      trackEvent('opened_approve_access_modal');
    }
  }, [open]);

  return (
    <Context.Provider value={{ open, setOpen }}>
      <>
        {open && <ApproveAccessModal visible={open} onCancel={() => setOpen(false)} />}
        {children}
      </>
    </Context.Provider>
  );
};

export const useApproveAccessModal = (): { open: boolean; setOpen: (data: boolean) => void } => {
  const context = useContext(Context);

  if (context === undefined) {
    throw new Error('useApproveAccessModal must be used within a ApproveAccessModalProvider');
  }
  return context;
};
